var map = {
	"./": 12383,
	"./@types/jstat.d": 40504,
	"./@types/jstat.d.ts": 40504,
	"./App": 49503,
	"./App.scss": 33737,
	"./App.test": 49089,
	"./App.test.tsx": 49089,
	"./App.tsx": 49503,
	"./assets/DINOT/DINOT-Black.otf": 81746,
	"./assets/DINOT/DINOT-BlackItalic.otf": 22622,
	"./assets/DINOT/DINOT-Bold.otf": 2226,
	"./assets/DINOT/DINOT-BoldItalic.otf": 75294,
	"./assets/DINOT/DINOT-Light.otf": 20891,
	"./assets/DINOT/DINOT-LightItalic.otf": 13387,
	"./assets/DINOT/DINOT-Medium.otf": 1542,
	"./assets/DINOT/DINOT-MediumItalic.otf": 31906,
	"./assets/DINOT/DINOT-Regular.otf": 2243,
	"./assets/DINOT/DINOT-RegularItalic.otf": 38499,
	"./assets/SvgIcon": 54975,
	"./assets/SvgIcon (old)": 14715,
	"./assets/SvgIcon (old).tsx": 14715,
	"./assets/SvgIcon.tsx": 54975,
	"./assets/dashboards/Basics.png": 2913,
	"./assets/dashboards/Civics.png": 49113,
	"./assets/dashboards/Education.png": 35584,
	"./assets/dashboards/Health.png": 80370,
	"./assets/dashboards/Physical_World.png": 15534,
	"./assets/dashboards/Safety.png": 58714,
	"./assets/dashboards/Work_Wealth.png": 25399,
	"./assets/icons/MoALogo.svg": 83445,
	"./assets/icons/helmsley_logo.png": 26202,
	"./assets/icons/measure_of_america.png": 98320,
	"./assets/icons/measure_of_america_WHITE.png": 14430,
	"./assets/icons/moa_logo.png": 61084,
	"./assets/icons/sbc/D2G_Logo.png": 56013,
	"./assets/pngs/CD/cd101.png": 45002,
	"./assets/pngs/CD/cd102.png": 75585,
	"./assets/pngs/CD/cd103.png": 54456,
	"./assets/pngs/CD/cd104.png": 87095,
	"./assets/pngs/CD/cd105.png": 57870,
	"./assets/pngs/CD/cd106.png": 11877,
	"./assets/pngs/CD/cd107.png": 45340,
	"./assets/pngs/CD/cd108.png": 54827,
	"./assets/pngs/CD/cd109.png": 33698,
	"./assets/pngs/CD/cd110.png": 61544,
	"./assets/pngs/CD/cd111.png": 93585,
	"./assets/pngs/CD/cd112.png": 33690,
	"./assets/pngs/CD/cd201.png": 20665,
	"./assets/pngs/CD/cd202.png": 6658,
	"./assets/pngs/CD/cd203.png": 70315,
	"./assets/pngs/CD/cd204.png": 78324,
	"./assets/pngs/CD/cd205.png": 99453,
	"./assets/pngs/CD/cd206.png": 15686,
	"./assets/pngs/CD/cd207.png": 783,
	"./assets/pngs/CD/cd208.png": 99128,
	"./assets/pngs/CD/cd209.png": 71841,
	"./assets/pngs/CD/cd210.png": 80699,
	"./assets/pngs/CD/cd211.png": 59154,
	"./assets/pngs/CD/cd212.png": 7337,
	"./assets/pngs/CD/cd301.png": 62760,
	"./assets/pngs/CD/cd302.png": 41091,
	"./assets/pngs/CD/cd303.png": 51258,
	"./assets/pngs/CD/cd304.png": 3317,
	"./assets/pngs/CD/cd305.png": 91692,
	"./assets/pngs/CD/cd306.png": 42375,
	"./assets/pngs/CD/cd307.png": 66590,
	"./assets/pngs/CD/cd308.png": 22345,
	"./assets/pngs/CD/cd309.png": 98144,
	"./assets/pngs/CD/cd310.png": 75126,
	"./assets/pngs/CD/cd311.png": 72063,
	"./assets/pngs/CD/cd312.png": 35204,
	"./assets/pngs/CD/cd313.png": 89101,
	"./assets/pngs/CD/cd314.png": 84242,
	"./assets/pngs/CD/cd315.png": 99067,
	"./assets/pngs/CD/cd316.png": 20736,
	"./assets/pngs/CD/cd317.png": 15209,
	"./assets/pngs/CD/cd318.png": 69342,
	"./assets/pngs/CD/cd401.png": 32735,
	"./assets/pngs/CD/cd402.png": 78084,
	"./assets/pngs/CD/cd403.png": 18029,
	"./assets/pngs/CD/cd404.png": 45522,
	"./assets/pngs/CD/cd405.png": 59739,
	"./assets/pngs/CD/cd406.png": 81408,
	"./assets/pngs/CD/cd407.png": 36233,
	"./assets/pngs/CD/cd408.png": 7326,
	"./assets/pngs/CD/cd409.png": 25639,
	"./assets/pngs/CD/cd410.png": 67601,
	"./assets/pngs/CD/cd411.png": 57384,
	"./assets/pngs/CD/cd412.png": 10595,
	"./assets/pngs/CD/cd413.png": 46490,
	"./assets/pngs/CD/cd414.png": 70261,
	"./assets/pngs/CD/cd501.png": 78894,
	"./assets/pngs/CD/cd502.png": 6725,
	"./assets/pngs/CD/cd503.png": 70812,
	"./assets/pngs/NTA/bk/bk0101.png": 64298,
	"./assets/pngs/NTA/bk/bk0102.png": 13281,
	"./assets/pngs/NTA/bk/bk0103.png": 45016,
	"./assets/pngs/NTA/bk/bk0104.png": 20183,
	"./assets/pngs/NTA/bk/bk0201.png": 89465,
	"./assets/pngs/NTA/bk/bk0202.png": 49730,
	"./assets/pngs/NTA/bk/bk0202_old.png": 12112,
	"./assets/pngs/NTA/bk/bk0203.png": 70859,
	"./assets/pngs/NTA/bk/bk0204.png": 20948,
	"./assets/pngs/NTA/bk/bk0301.png": 56360,
	"./assets/pngs/NTA/bk/bk0302.png": 93219,
	"./assets/pngs/NTA/bk/bk0401.png": 74655,
	"./assets/pngs/NTA/bk/bk0402.png": 37796,
	"./assets/pngs/NTA/bk/bk0501.png": 73774,
	"./assets/pngs/NTA/bk/bk0502.png": 92549,
	"./assets/pngs/NTA/bk/bk0503.png": 58684,
	"./assets/pngs/NTA/bk/bk0504.png": 58643,
	"./assets/pngs/NTA/bk/bk0505.png": 7882,
	"./assets/pngs/NTA/bk/bk0601.png": 82141,
	"./assets/pngs/NTA/bk/bk0602.png": 40902,
	"./assets/pngs/NTA/bk/bk0701.png": 54348,
	"./assets/pngs/NTA/bk/bk0702.png": 56999,
	"./assets/pngs/NTA/bk/bk0703.png": 4510,
	"./assets/pngs/NTA/bk/bk0801.png": 95155,
	"./assets/pngs/NTA/bk/bk0802.png": 20664,
	"./assets/pngs/NTA/bk/bk0901.png": 61442,
	"./assets/pngs/NTA/bk/bk0902.png": 9625,
	"./assets/pngs/NTA/bk/bk1001.png": 24124,
	"./assets/pngs/NTA/bk/bk1002.png": 12855,
	"./assets/pngs/NTA/bk/bk1101.png": 92845,
	"./assets/pngs/NTA/bk/bk1102.png": 11222,
	"./assets/pngs/NTA/bk/bk1103.png": 7551,
	"./assets/pngs/NTA/bk/bk1201.png": 84478,
	"./assets/pngs/NTA/bk/bk1202.png": 21205,
	"./assets/pngs/NTA/bk/bk1203.png": 9580,
	"./assets/pngs/NTA/bk/bk1204.png": 42627,
	"./assets/pngs/NTA/bk/bk1301.png": 18671,
	"./assets/pngs/NTA/bk/bk1302.png": 79860,
	"./assets/pngs/NTA/bk/bk1303.png": 17341,
	"./assets/pngs/NTA/bk/bk1401.png": 10456,
	"./assets/pngs/NTA/bk/bk1402.png": 84947,
	"./assets/pngs/NTA/bk/bk1403.png": 29738,
	"./assets/pngs/NTA/bk/bk1501.png": 75593,
	"./assets/pngs/NTA/bk/bk1502.png": 26802,
	"./assets/pngs/NTA/bk/bk1503.png": 75803,
	"./assets/pngs/NTA/bk/bk1601.png": 25562,
	"./assets/pngs/NTA/bk/bk1602.png": 55729,
	"./assets/pngs/NTA/bk/bk1701.png": 72363,
	"./assets/pngs/NTA/bk/bk1702.png": 2512,
	"./assets/pngs/NTA/bk/bk1703.png": 99417,
	"./assets/pngs/NTA/bk/bk1704.png": 6342,
	"./assets/pngs/NTA/bk/bk1801.png": 43828,
	"./assets/pngs/NTA/bk/bk1802.png": 48943,
	"./assets/pngs/NTA/bk/bk1803.png": 83750,
	"./assets/pngs/NTA/bx/bx0101.png": 15600,
	"./assets/pngs/NTA/bx/bx0102.png": 3243,
	"./assets/pngs/NTA/bx/bx0201.png": 27779,
	"./assets/pngs/NTA/bx/bx0202.png": 42504,
	"./assets/pngs/NTA/bx/bx0301.png": 26514,
	"./assets/pngs/NTA/bx/bx0302.png": 17225,
	"./assets/pngs/NTA/bx/bx0303.png": 62400,
	"./assets/pngs/NTA/bx/bx0401.png": 66181,
	"./assets/pngs/NTA/bx/bx0402.png": 38350,
	"./assets/pngs/NTA/bx/bx0403.png": 37847,
	"./assets/pngs/NTA/bx/bx0501.png": 52820,
	"./assets/pngs/NTA/bx/bx0502.png": 74287,
	"./assets/pngs/NTA/bx/bx0503.png": 92742,
	"./assets/pngs/NTA/bx/bx0601.png": 67847,
	"./assets/pngs/NTA/bx/bx0602.png": 65196,
	"./assets/pngs/NTA/bx/bx0603.png": 17461,
	"./assets/pngs/NTA/bx/bx0701.png": 10102,
	"./assets/pngs/NTA/bx/bx0702.png": 24077,
	"./assets/pngs/NTA/bx/bx0703.png": 70180,
	"./assets/pngs/NTA/bx/bx0801.png": 937,
	"./assets/pngs/NTA/bx/bx0802.png": 35794,
	"./assets/pngs/NTA/bx/bx0803.png": 84795,
	"./assets/pngs/NTA/bx/bx0901.png": 19448,
	"./assets/pngs/NTA/bx/bx0902.png": 93939,
	"./assets/pngs/NTA/bx/bx0903.png": 55082,
	"./assets/pngs/NTA/bx/bx0904.png": 23397,
	"./assets/pngs/NTA/bx/bx1001.png": 77666,
	"./assets/pngs/NTA/bx/bx1002.png": 60601,
	"./assets/pngs/NTA/bx/bx1003.png": 54352,
	"./assets/pngs/NTA/bx/bx1004.png": 39727,
	"./assets/pngs/NTA/bx/bx1101.png": 76755,
	"./assets/pngs/NTA/bx/bx1102.png": 81144,
	"./assets/pngs/NTA/bx/bx1103.png": 2273,
	"./assets/pngs/NTA/bx/bx1104.png": 3790,
	"./assets/pngs/NTA/bx/bx1201.png": 53152,
	"./assets/pngs/NTA/bx/bx1202.png": 8187,
	"./assets/pngs/NTA/bx/bx1203.png": 59186,
	"./assets/pngs/NTA/mn/mn0101.png": 10754,
	"./assets/pngs/NTA/mn/mn0102.png": 24761,
	"./assets/pngs/NTA/mn/mn0201.png": 41937,
	"./assets/pngs/NTA/mn/mn0202.png": 11770,
	"./assets/pngs/NTA/mn/mn0203.png": 29347,
	"./assets/pngs/NTA/mn/mn0301.png": 63968,
	"./assets/pngs/NTA/mn/mn0302.png": 42299,
	"./assets/pngs/NTA/mn/mn0303.png": 28082,
	"./assets/pngs/NTA/mn/mn0401.png": 12727,
	"./assets/pngs/NTA/mn/mn0401_old.png": 36269,
	"./assets/pngs/NTA/mn/mn0402.png": 54620,
	"./assets/pngs/NTA/mn/mn0501.png": 33446,
	"./assets/pngs/NTA/mn/mn0502.png": 14653,
	"./assets/pngs/NTA/mn/mn0601.png": 28949,
	"./assets/pngs/NTA/mn/mn0602.png": 92222,
	"./assets/pngs/NTA/mn/mn0603.png": 68007,
	"./assets/pngs/NTA/mn/mn0604.png": 88392,
	"./assets/pngs/NTA/mn/mn0701.png": 33956,
	"./assets/pngs/NTA/mn/mn0702.png": 19231,
	"./assets/pngs/NTA/mn/mn0703.png": 65430,
	"./assets/pngs/NTA/mn/mn0801.png": 77659,
	"./assets/pngs/NTA/mn/mn0802.png": 99328,
	"./assets/pngs/NTA/mn/mn0803.png": 93801,
	"./assets/pngs/NTA/mn/mn0901.png": 83882,
	"./assets/pngs/NTA/mn/mn0902.png": 32865,
	"./assets/pngs/NTA/mn/mn0903.png": 60152,
	"./assets/pngs/NTA/mn/mn1001.png": 47060,
	"./assets/pngs/NTA/mn/mn1002.png": 37903,
	"./assets/pngs/NTA/mn/mn1101.png": 2949,
	"./assets/pngs/NTA/mn/mn1102.png": 32590,
	"./assets/pngs/NTA/mn/mn1201.png": 99894,
	"./assets/pngs/NTA/mn/mn1202.png": 90573,
	"./assets/pngs/NTA/mn/mn1203.png": 64420,
	"./assets/pngs/NTA/qn/qn0101.png": 60746,
	"./assets/pngs/NTA/qn/qn0102.png": 9729,
	"./assets/pngs/NTA/qn/qn0103.png": 25112,
	"./assets/pngs/NTA/qn/qn0104.png": 279,
	"./assets/pngs/NTA/qn/qn0105.png": 57262,
	"./assets/pngs/NTA/qn/qn0201.png": 69561,
	"./assets/pngs/NTA/qn/qn0202.png": 29826,
	"./assets/pngs/NTA/qn/qn0203.png": 50955,
	"./assets/pngs/NTA/qn/qn0301.png": 36456,
	"./assets/pngs/NTA/qn/qn0302.png": 73315,
	"./assets/pngs/NTA/qn/qn0303.png": 51738,
	"./assets/pngs/NTA/qn/qn0401.png": 54751,
	"./assets/pngs/NTA/qn/qn0402.png": 17892,
	"./assets/pngs/NTA/qn/qn0501.png": 53870,
	"./assets/pngs/NTA/qn/qn0502.png": 72645,
	"./assets/pngs/NTA/qn/qn0503.png": 55132,
	"./assets/pngs/NTA/qn/qn0504.png": 38739,
	"./assets/pngs/NTA/qn/qn0601.png": 62237,
	"./assets/pngs/NTA/qn/qn0602.png": 20998,
	"./assets/pngs/NTA/qn/qn0701.png": 34444,
	"./assets/pngs/NTA/qn/qn0702.png": 37095,
	"./assets/pngs/NTA/qn/qn0703.png": 84606,
	"./assets/pngs/NTA/qn/qn0704.png": 67697,
	"./assets/pngs/NTA/qn/qn0705.png": 57480,
	"./assets/pngs/NTA/qn/qn0706.png": 94339,
	"./assets/pngs/NTA/qn/qn0707.png": 46586,
	"./assets/pngs/NTA/qn/qn0801.png": 75251,
	"./assets/pngs/NTA/qn/qn0802.png": 760,
	"./assets/pngs/NTA/qn/qn0803.png": 85377,
	"./assets/pngs/NTA/qn/qn0804.png": 32910,
	"./assets/pngs/NTA/qn/qn0805.png": 75927,
	"./assets/pngs/NTA/qn/qn0901.png": 41538,
	"./assets/pngs/NTA/qn/qn0902.png": 89721,
	"./assets/pngs/NTA/qn/qn0903.png": 92816,
	"./assets/pngs/NTA/qn/qn0904.png": 35663,
	"./assets/pngs/NTA/qn/qn0905.png": 96646,
	"./assets/pngs/NTA/qn/qn1001.png": 4220,
	"./assets/pngs/NTA/qn/qn1002.png": 92951,
	"./assets/pngs/NTA/qn/qn1003.png": 19310,
	"./assets/pngs/NTA/qn/qn1101.png": 72941,
	"./assets/pngs/NTA/qn/qn1102.png": 91318,
	"./assets/pngs/NTA/qn/qn1103.png": 87647,
	"./assets/pngs/NTA/qn/qn1104.png": 36320,
	"./assets/pngs/NTA/qn/qn1201.png": 64574,
	"./assets/pngs/NTA/qn/qn1202.png": 1301,
	"./assets/pngs/NTA/qn/qn1203.png": 89676,
	"./assets/pngs/NTA/qn/qn1204.png": 39075,
	"./assets/pngs/NTA/qn/qn1205.png": 32890,
	"./assets/pngs/NTA/qn/qn1206.png": 9137,
	"./assets/pngs/NTA/qn/qn1301.png": 98767,
	"./assets/pngs/NTA/qn/qn1302.png": 76308,
	"./assets/pngs/NTA/qn/qn1303.png": 97437,
	"./assets/pngs/NTA/qn/qn1304.png": 4642,
	"./assets/pngs/NTA/qn/qn1305.png": 68299,
	"./assets/pngs/NTA/qn/qn1306.png": 86544,
	"./assets/pngs/NTA/qn/qn1307.png": 18649,
	"./assets/pngs/NTA/qn/qn1401.png": 90552,
	"./assets/pngs/NTA/qn/qn1402.png": 87424,
	"./assets/pngs/NTA/qn/qn1403.png": 87453,
	"./assets/pngs/NTA/si/si0101.png": 91020,
	"./assets/pngs/NTA/si/si0102.png": 59495,
	"./assets/pngs/NTA/si/si0103.png": 88158,
	"./assets/pngs/NTA/si/si0104.png": 24273,
	"./assets/pngs/NTA/si/si0105.png": 84328,
	"./assets/pngs/NTA/si/si0106.png": 21187,
	"./assets/pngs/NTA/si/si0107.png": 99610,
	"./assets/pngs/NTA/si/si0201.png": 58303,
	"./assets/pngs/NTA/si/si0202.png": 44740,
	"./assets/pngs/NTA/si/si0203.png": 70893,
	"./assets/pngs/NTA/si/si0204.png": 89330,
	"./assets/pngs/NTA/si/si0301.png": 99950,
	"./assets/pngs/NTA/si/si0302.png": 71749,
	"./assets/pngs/NTA/si/si0303.png": 42332,
	"./assets/pngs/NTA/si/si0304.png": 42291,
	"./assets/pngs/NTA/si/si0305.png": 87082,
	"./assets/pngs/NTA/si/si9561.png": 71349,
	"./assets/pngs/StoriesAsset/Compare.png": 44288,
	"./assets/pngs/StoriesAsset/HDI.png": 7932,
	"./assets/pngs/StoriesAsset/MentalHealth.png": 43744,
	"./assets/pngs/StoriesAsset/MentalHealthFacilities.png": 48955,
	"./assets/pngs/StoriesAsset/Nutrition.png": 71969,
	"./assets/pngs/StoriesAsset/WorkWealth.png": 45473,
	"./components/charts/Bar": 23276,
	"./components/charts/Bar.tsx": 23276,
	"./components/charts/BarMeta": 10915,
	"./components/charts/BarMeta.tsx": 10915,
	"./components/charts/COT": 51785,
	"./components/charts/COT.tsx": 51785,
	"./components/charts/COTMeta": 16202,
	"./components/charts/COTMeta.tsx": 16202,
	"./components/charts/CorrelationCard": 40540,
	"./components/charts/CorrelationCard.tsx": 40540,
	"./components/charts/Count": 74730,
	"./components/charts/Count.tsx": 74730,
	"./components/charts/CountMeta": 88457,
	"./components/charts/CountMeta.tsx": 88457,
	"./components/charts/DBBar": 31598,
	"./components/charts/DBBar.tsx": 31598,
	"./components/charts/DBCountOnly": 35742,
	"./components/charts/DBCountOnly.tsx": 35742,
	"./components/charts/DBOneOrTwoColStats": 66201,
	"./components/charts/DBOneOrTwoColStats.tsx": 66201,
	"./components/charts/DBRankedStatList": 31698,
	"./components/charts/DBRankedStatList.tsx": 31698,
	"./components/charts/DBStackedStats": 8389,
	"./components/charts/DBStackedStats.tsx": 8389,
	"./components/charts/DBStatList": 14723,
	"./components/charts/DBStatList.tsx": 14723,
	"./components/charts/DBWaffle": 78040,
	"./components/charts/DBWaffle.tsx": 78040,
	"./components/charts/DeviationFromAverage": 18641,
	"./components/charts/DeviationFromAverage.tsx": 18641,
	"./components/charts/DeviationFromAverageInline": 88594,
	"./components/charts/DeviationFromAverageInline.tsx": 88594,
	"./components/charts/GlobeMap": 26952,
	"./components/charts/GlobeMap.tsx": 26952,
	"./components/charts/Histogram": 53321,
	"./components/charts/Histogram.tsx": 53321,
	"./components/charts/HistogramDynamic": 98810,
	"./components/charts/HistogramDynamic.tsx": 98810,
	"./components/charts/HistogramMeta": 88746,
	"./components/charts/HistogramMeta.tsx": 88746,
	"./components/charts/HistogramStatic": 38251,
	"./components/charts/HistogramStatic.tsx": 38251,
	"./components/charts/IFrameBlurb": 76800,
	"./components/charts/IFrameBlurb.tsx": 76800,
	"./components/charts/Image": 19844,
	"./components/charts/Image.tsx": 19844,
	"./components/charts/ImageBlurb": 59445,
	"./components/charts/ImageBlurb.tsx": 59445,
	"./components/charts/InlineSparkline": 56321,
	"./components/charts/InlineSparkline.ts": 56321,
	"./components/charts/List": 23043,
	"./components/charts/List.tsx": 23043,
	"./components/charts/ListMeta": 32260,
	"./components/charts/ListMeta.tsx": 32260,
	"./components/charts/MobileSwarm": 29661,
	"./components/charts/MobileSwarm.tsx": 29661,
	"./components/charts/Pie": 83697,
	"./components/charts/Pie.tsx": 83697,
	"./components/charts/PieMeta": 52770,
	"./components/charts/PieMeta.tsx": 52770,
	"./components/charts/Pyramid": 4783,
	"./components/charts/Pyramid.tsx": 4783,
	"./components/charts/RSliderChart": 69276,
	"./components/charts/RSliderChart.tsx": 69276,
	"./components/charts/RaceGenderHistograms": 1046,
	"./components/charts/RaceGenderHistograms.tsx": 1046,
	"./components/charts/RaceGenderSwarms": 7572,
	"./components/charts/RaceGenderSwarms.tsx": 7572,
	"./components/charts/RangeSwarm": 45962,
	"./components/charts/RangeSwarm.tsx": 45962,
	"./components/charts/RangeSwarmDynamic": 5031,
	"./components/charts/RangeSwarmDynamic.tsx": 5031,
	"./components/charts/RangeSwarmMeta": 23721,
	"./components/charts/RangeSwarmMeta.tsx": 23721,
	"./components/charts/RangeSwarmStatic": 71740,
	"./components/charts/RangeSwarmStatic.tsx": 71740,
	"./components/charts/ScatterPlot": 37912,
	"./components/charts/ScatterPlot.tsx": 37912,
	"./components/charts/StackedHistograms": 65089,
	"./components/charts/StackedHistograms.tsx": 65089,
	"./components/charts/StackedSwarms": 95203,
	"./components/charts/StackedSwarms.tsx": 95203,
	"./components/charts/Swarm": 62463,
	"./components/charts/Swarm.tsx": 62463,
	"./components/charts/SwarmDynamic": 98724,
	"./components/charts/SwarmDynamic.tsx": 98724,
	"./components/charts/SwarmMeta": 12952,
	"./components/charts/SwarmMeta.tsx": 12952,
	"./components/charts/SwarmStatic": 57593,
	"./components/charts/SwarmStatic.tsx": 57593,
	"./components/charts/Time": 91288,
	"./components/charts/Time.tsx": 91288,
	"./components/charts/Waffle": 75358,
	"./components/charts/Waffle.tsx": 75358,
	"./components/charts/WaffleMeta": 81781,
	"./components/charts/WaffleMeta.tsx": 81781,
	"./components/charts/WideBlurb": 67155,
	"./components/charts/WideBlurb.scss": 51157,
	"./components/charts/WideBlurb.tsx": 67155,
	"./components/inputs/ExportModal": 24642,
	"./components/inputs/ExportModal.tsx": 24642,
	"./components/inputs/GeoChangeModal": 51373,
	"./components/inputs/GeoChangeModal.tsx": 51373,
	"./components/inputs/GlobalSwipeWrapper": 10733,
	"./components/inputs/GlobalSwipeWrapper.tsx": 10733,
	"./components/inputs/IndicatorDropdown": 67359,
	"./components/inputs/IndicatorDropdown.tsx": 67359,
	"./components/inputs/MapClearPointsControl": 2808,
	"./components/inputs/MapClearPointsControl.tsx": 2808,
	"./components/inputs/MapHighlightedFeature": 89482,
	"./components/inputs/MapHighlightedFeature.tsx": 89482,
	"./components/inputs/MapRadioControl": 40373,
	"./components/inputs/MapRadioControl.tsx": 40373,
	"./components/inputs/MapZoomControl": 67885,
	"./components/inputs/MapZoomControl.tsx": 67885,
	"./components/inputs/MobileIndicatorSelect": 60266,
	"./components/inputs/MobileIndicatorSelect.tsx": 60266,
	"./components/inputs/ModuleSearch": 82967,
	"./components/inputs/ModuleSearch.tsx": 82967,
	"./components/inputs/RangeSwarmCalibrationPanel": 17352,
	"./components/inputs/RangeSwarmCalibrationPanel.tsx": 17352,
	"./components/inputs/Selector": 83724,
	"./components/inputs/Selector.tsx": 83724,
	"./components/inputs/ShareBar": 19882,
	"./components/inputs/ShareBar.tsx": 19882,
	"./components/inputs/XShareButton": 98686,
	"./components/inputs/XShareButton.tsx": 98686,
	"./components/maps/Layers/ChoroplethLayer": 16439,
	"./components/maps/Layers/ChoroplethLayer.tsx": 16439,
	"./components/maps/Layers/CreatePanes": 80299,
	"./components/maps/Layers/CreatePanes.tsx": 80299,
	"./components/maps/Layers/PointLayers": 64043,
	"./components/maps/Layers/PointLayers.tsx": 64043,
	"./components/maps/MainMap": 48507,
	"./components/maps/MainMap.tsx": 48507,
	"./components/meta/BivariateLegend": 82749,
	"./components/meta/BivariateLegend.tsx": 82749,
	"./components/structure/AboutScreen": 90764,
	"./components/structure/AboutScreen.tsx": 90764,
	"./components/structure/BackToStoriesButton": 28650,
	"./components/structure/BackToStoriesButton.tsx": 28650,
	"./components/structure/ChartCard": 15710,
	"./components/structure/ChartCard.tsx": 15710,
	"./components/structure/ChartList": 97455,
	"./components/structure/ChartList.tsx": 97455,
	"./components/structure/ChartPage": 46986,
	"./components/structure/ChartPage.tsx": 46986,
	"./components/structure/MainHistogram": 42404,
	"./components/structure/MainHistogram.tsx": 42404,
	"./components/structure/MenuBar": 95007,
	"./components/structure/MenuBar.tsx": 95007,
	"./components/structure/SearchPopup": 11689,
	"./components/structure/SearchPopup.tsx": 11689,
	"./components/structure/SearchPopupAlgolia": 99904,
	"./components/structure/SearchPopupAlgolia.tsx": 99904,
	"./components/structure/SplashScreen": 31482,
	"./components/structure/SplashScreen.tsx": 31482,
	"./components/structure/SpreadOutScreen": 69400,
	"./components/structure/SpreadOutScreen.tsx": 69400,
	"./components/structure/StoriesBar": 24465,
	"./components/structure/StoriesBar.tsx": 24465,
	"./components/utilities/Colors": 39638,
	"./components/utilities/Colors.tsx": 39638,
	"./components/utilities/DynamicImage": 34636,
	"./components/utilities/DynamicImage.tsx": 34636,
	"./components/utilities/Utilities": 51660,
	"./components/utilities/Utilities.tsx": 51660,
	"./components/utilities/exports/image/ExportToImage": 15734,
	"./components/utilities/exports/image/ExportToImage.tsx": 15734,
	"./components/utilities/exports/image/ExportToImage___dom-to-image-more": 53141,
	"./components/utilities/exports/image/ExportToImage___dom-to-image-more.tsx": 53141,
	"./components/utilities/exports/image/ExportToImage___html-to-image": 50710,
	"./components/utilities/exports/image/ExportToImage___html-to-image.tsx": 50710,
	"./components/utilities/exports/image/ExportToImage___html2canvas": 5870,
	"./components/utilities/exports/image/ExportToImage___html2canvas.tsx": 5870,
	"./components/utilities/exports/image/ExportToImage___node.js_puppeteer": 79961,
	"./components/utilities/exports/image/ExportToImage___node.js_puppeteer.tsx": 79961,
	"./components/utilities/exports/image/README.md": 1953,
	"./components/utilities/exports/xlsx/ExportToExcel": 19899,
	"./components/utilities/exports/xlsx/ExportToExcel.tsx": 19899,
	"./components/utilities/ga": 1474,
	"./components/utilities/ga.tsx": 1474,
	"./components/utilities/posthog": 90532,
	"./components/utilities/posthog.tsx": 90532,
	"./config/siteConfig": 97192,
	"./config/siteConfig.nyc": 47168,
	"./config/siteConfig.nyc.ts": 47168,
	"./config/siteConfig.sb": 39305,
	"./config/siteConfig.sb.ts": 39305,
	"./config/siteConfig.ts": 97192,
	"./data/DataContext": 74943,
	"./data/DataContext.tsx": 74943,
	"./data/GlobalStore": 17113,
	"./data/GlobalStore.tsx": 17113,
	"./data/StatusStore": 98272,
	"./data/StatusStore.tsx": 98272,
	"./index": 12383,
	"./index.scss": 13782,
	"./index.tsx": 12383,
	"./logo.svg": 69445,
	"./react-app-env.d": 55059,
	"./react-app-env.d.ts": 55059,
	"./reportWebVitals": 16469,
	"./reportWebVitals.ts": 16469,
	"./setupTests": 35374,
	"./setupTests.ts": 35374,
	"./views/Comparisons": 74131,
	"./views/Comparisons.tsx": 74131,
	"./views/Dashboards": 10270,
	"./views/Dashboards.tsx": 10270,
	"./views/DataStories": 95618,
	"./views/DataStories.tsx": 95618,
	"./views/MobileView": 52444,
	"./views/MobileView.scss": 55570,
	"./views/MobileView.tsx": 52444,
	"./views/RaceAndGender": 33236,
	"./views/RaceAndGender.tsx": 33236,
	"./views/StatExplorer": 29970,
	"./views/StatExplorer.tsx": 29970,
	"./views/views.scss": 81949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;